import React from 'react';
import { Row } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import Accordion from 'components/Accordion';
import { store } from 'redux/store';
import { setRequestTriggered } from 'redux/reducers/meteorologyFieldsClassicComparatorControlPanelReducer';
import useGetImagesParams from 'hooks/Meteorology/Fields/ClassicComparator/useGetImagesParams';
import useApplyClassicComparatorDefaultInterval from 'hooks/Meteorology/Fields/ClassicComparator/useApplyClassicComparatorDefaultInterval';
import useApplyClassicComparatorOpenDefaults from 'hooks/Meteorology/Fields/ClassicComparator/useApplyClassicComparatorOpenDefaults';
import useApplyClassicComparatorOpenQuery from 'hooks/Meteorology/Fields/ClassicComparator/useApplyClassicComparatorOpenQuery';
import useClassicComparatorUtility from 'utils/hooks/meteorology/classicComparator/useClassicComparatorUtility';
import VariableSelector from './VariableSelector';
import DateSelectors from './DateSelectors';
import BaseModel from './BaseModel';
import ConfrontingModel from './ConfrontingModel';

export default function ClassicComparator() {
  useApplyClassicComparatorOpenDefaults();
  useApplyClassicComparatorDefaultInterval();
  useApplyClassicComparatorOpenQuery();
  const { resetPreferences } = useClassicComparatorUtility();
  const params = useGetImagesParams();
  const triggerRequest = () => store.dispatch(setRequestTriggered(true));

  return (
    <>
      <Accordion defaultActiveKey="variable">
        <VariableSelector />
        <Accordion.Item eventKey="models">
          <Accordion.Header>Modelos</Accordion.Header>
          <Accordion.Body>
            <ConfrontingModel />
            <BaseModel />
          </Accordion.Body>
        </Accordion.Item>
        <DateSelectors />
      </Accordion>
      <Row className="pt-5">
        <Button
          disabled={!params}
          onClick={triggerRequest}
        >
          Realizar consulta
        </Button>
      </Row>
      <Row>
        <Button type="tertiary" className="clear-filters mt-1" onClick={resetPreferences}>
          Limpar filtros
        </Button>
      </Row>
    </>
  );
}
